import { FormItemLabel } from "@portal/components/form";
import { FormDropdownComponent } from "@portal/components/form/fieldLayouts";
import { FormNAICSCodeSelect } from "@portal/components/form/fields";
import { cn } from "@portal/components/lib/utils";
import { useIsCommercialSuretyEnabled } from "@portal/hooks/useIsCommercialSuretyEnabled";
import { useFormContext } from "react-hook-form";
import { PaymentAndPerformanceBondsField } from "../../../../../agent/account/create/PaymentAndPerformanceBondsField";
import type { AdminCombinedFormData } from "../../schema";
import { QuickSubmitFormItemGroup } from "../QuickSubmitFormItemGroup";

export const AccountDetailsSection = () => {
	const formMethods = useFormContext<AdminCombinedFormData>();
	const { control, watch } = formMethods;
	const naicsCodes = watch("account.naicsCodes");
	const hasSelectedItems = naicsCodes && naicsCodes.length > 0;
	const isCommercialSuretyEnabled = useIsCommercialSuretyEnabled();

	return (
		<>
			<QuickSubmitFormItemGroup data-testid="model-size">
				<FormDropdownComponent
					formMethods={formMethods}
					name={"account.modelSize"}
					label="Model Size"
					compact
					anchor="bottom start"
					options={[
						{ value: "small", label: "Small, up to $500k" },
						{ value: "medium", label: "Medium, $500k - $1M" },
						{ value: "large", label: "Large, over $1M" },
					]}
				/>
			</QuickSubmitFormItemGroup>
			{isCommercialSuretyEnabled && (
				<QuickSubmitFormItemGroup className="col-span-2">
					<PaymentAndPerformanceBondsField compact />
				</QuickSubmitFormItemGroup>
			)}
			<QuickSubmitFormItemGroup className="col-span-2">
				<FormItemLabel name="account.naicsCodes">Specialty</FormItemLabel>
				<div className={cn(hasSelectedItems && "max-h-36 overflow-y-auto")}>
					<FormNAICSCodeSelect
						name={"account.naicsCodes"}
						control={control}
						selectText="Select specialties"
						editText="Edit Specialties"
						title="Select Account Specialties"
						searchPlaceholder="Search specialties..."
						buttonClassName={cn("sticky top-[10px] right-[5px]")}
						listClassName="max-w-[355px]"
						inline={true}
					/>
				</div>
			</QuickSubmitFormItemGroup>
		</>
	);
};
